import { writable } from "svelte/store";

const createStore = () => {
  const state = {
    captureMode: writable(false),
    // TODO: 타입 정의
    embeddedInserterHorizontalAlign: writable<
      "center" | "left" | "right" | undefined
    >(undefined),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t: writable<(key: string, options?: { [key: string]: any }) => string>(
      (key) => key
    ),
    origin: writable<string | undefined>(undefined),
  };
  return {
    state,
    reset: () => {
      state.captureMode.set(false);
    },
  };
};

export default createStore;
